import PropTypes from 'prop-types';

import success from '../../../assets/images/successIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function SuccessPopup({ onRequestClose }) {
  const dispatch = useAppDispatch();

  // onRequestClose приходит из ModalWrapper и делает то же, что клик по
  // фону/Escape: закрывает попап И применяет onCloseHref (переход на '/'
  // после успешного оформления). Раньше кнопки здесь просто гасили попап,
  // из-за чего форма оставалась открытой и заявку можно было отправить
  // повторно.
  const handleClosePopup = onRequestClose || (() => dispatch(closePopup()));

  return (
    <div className={styles.successPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.successTextWrapper}>
        <img src={success} alt="иконка успех" />
        <h2 className={styles.successTitle}>Ваш заказ успешно создан!</h2>
        <h3 className={styles.successSubTitle}>
          {/* Вы создали заказ на сдачу вещей на хранение */}
        </h3>
        <p className={styles.successText}>
          Посмотреть детали заказа можно в разделе «Мои заказы»
        </p>
      </div>
      <RedButton text="Хорошо" onClick={handleClosePopup} width={308} height={54} />
    </div>
  );
}

SuccessPopup.propTypes = {
  onRequestClose: PropTypes.func,
};

export default SuccessPopup;
